import React from 'react';
import fr from 'facet-rest';
import { pick } from 'Helpers/Affordances';
import { useNewClientContext } from 'Context/NewClientContext';
import OnboardingRedirect from 'Components/ClientApp/OnboardingRedirect';
import CombinedApp from 'Components/ClientApp/CombinedApp';

const ClientPicker = () => {
  const { clientResource } = useNewClientContext();

  const Component = pick(clientResource, {
    [fr.relationships.nextOnboardingStep.name]: OnboardingRedirect,
  }, CombinedApp);

  return <Component />;
};

export default ClientPicker;
